import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';

import { Observable, throwError } from 'rxjs';
import { catchError, retry } from 'rxjs/operators';
import { ConstantsService } from '../../utils/constants.service';

@Injectable({
  providedIn: 'root'
})
export class StoresService {
  // Define API
  apiURL = ConstantsService.api.frontEndV2;
  apiURLV1 = ConstantsService.api.frontEnd;

  constructor(private http: HttpClient) { }

  /*========================================
    Begin CRUD Methods for consuming RESTful API
  =========================================*/

  // Http Options
  httpOptions = {
    headers: new HttpHeaders({
      'Content-Type': 'application/json',
    }),
  };

  /**
   * HttpClient API get() method => Fetch group apis list
   * @returns
   */
  get(filter = ''): Observable<any> {
    return this.http
      .get<any>(this.apiURL + `/stores?${filter}` + '&isAdmin')
      .pipe(retry(1), catchError(this.handleError));
  }

  /**
   * HttpClient API post() method => Create any
   * @param any
   * @returns
   */
  add(data: any): Observable<any> {
    return this.http
      .post<any>(
        this.apiURLV1 + '/stores',
        JSON.stringify(data),
        this.httpOptions
      )
      .pipe(retry(1), catchError(this.handleError));
  }

  /**
   * HttpClient API put() method => Update data addAges
   * @param id
   * @returns
   */
  addAges(id: string, data: any) {
    return this.http
      .put<any>(
        `${this.apiURLV1}/stores/${id}/add-ages`,
        JSON.stringify(data),
        this.httpOptions
      )
      .pipe(retry(1), catchError(this.handleError));
  }

  /**
   * HttpClient API put() method => Update data
   * @param id
   * @param data
   * @returns
   */
  update(id: any, data: any): Observable<any> {
    return this.http
      .put<any>(
        this.apiURL + '/stores/' + id,
        JSON.stringify(data),
        this.httpOptions
      )
      .pipe(retry(1), catchError(this.handleError));
  }

  /**
   * HttpClient API put() method => Update data
   * @param id
   * @param data
   * @returns
   */
  updateOpenCloseHour(id: any, data: any): Observable<any> {
    return this.http
      .put<any>(
        this.apiURL + '/stores/' + id + '/open-close-hour',
        JSON.stringify(data),
        this.httpOptions
      )
      .pipe(retry(1), catchError(this.handleError));
  }

  /**
   * HttpClient API put() method => Update data
   * @param id
   * @param data
   * @returns
   */
  updateSettingStores(id: any, data: any): Observable<any> {
    return this.http
      .put<any>(
        this.apiURL + `/stores/${id}/setting-care-customer`,
        JSON.stringify(data),
        this.httpOptions
      )
      .pipe(retry(1), catchError(this.handleError));
  }

  /**
   * HttpClient API put() method => Update data
   * @param id
   * @param data
   * @returns
   */
  updateAge(id: any, idAge: any, data: any): Observable<any> {
    return this.http
      .put<any>(
        this.apiURLV1 + `/stores/${id}/update/${idAge}`,
        JSON.stringify(data),
        this.httpOptions
      )
      .pipe(retry(1), catchError(this.handleError));
  }

  /**
   * HttpClient API put() method => Update many data
   * @param ids 
   * @param data 
   * @returns 
   */
  updateMany(ids: any, data: any): Observable<any> {
    return this.http
      .put<any>(
        this.apiURL + '/stores/' + ids + '/ids',
        JSON.stringify(data),
        this.httpOptions
      )
      .pipe(retry(1), catchError(this.handleError));
  }

  /**
   * HttpClient API put() method => Detail data
   * @param id 
   * @param data 
   * @returns 
   */
  detail(id: any, data: any): Observable<any> {
    return this.http
      .put<any>(
        this.apiURL + '/stores/' + id,
        JSON.stringify(data),
        this.httpOptions
      )
      .pipe(retry(1), catchError(this.handleError));
  }

  /**
   * HttpClient API put() method => Update data removePackage
   * @param id
   * @param body
   * @returns
   */
  removeAge(id: string, body: any) {
    return this.http
      .put<any>(
        `${this.apiURLV1}/stores/${id}/remove-ages`,
        JSON.stringify(body),
        this.httpOptions
      )
      .pipe(retry(1), catchError(this.handleError));
  }

  /**
   * HttpClient API delete() method => Delete data
   * @param id
   * @returns
   */
  delete(id: any) {
    return this.http
      .delete<any>(this.apiURL + '/stores/' + id, this.httpOptions)
      .pipe(retry(1), catchError(this.handleError));
  }

  /**
   * HttpClient API delete() method => Delete data
   * @param ids
   * @returns
   */
  deleteManyByIds(ids: any) {
    return this.http
      .delete<any>(
        `${this.apiURL}/stores/${ids}/ids`,
        this.httpOptions
      )
      .pipe(retry(1), catchError(this.handleError));
  }

  /**
   * HttpClient API get() method => Fetch tinhTp
   * @param id
   * @returns
   */
  find(id: any, filter = ''): Observable<any> {
    return this.http
      .get<any>(this.apiURL + '/stores/' + id + '?isAdmin' + `&${filter}`)
      .pipe(retry(1), catchError(this.handleError));
  }

  /**
   * HttpClient API get() method => paginate tinhTp with start page = 1 and limit
   * @param params
   * @returns
   */
  paginate(params: {
    page: number;
    limit: number;
    filter: string;
    fields: string;
    populate: string;
  }
  ): Observable<any> {
    let url = `${this.apiURL}/stores/paginate?page=${params.page}&limit=${params.limit}&${params.filter}` + '&isAdmin';

    if (params.fields) url = url.concat(`&fields=${params.fields}`);
    if (params.populate) url = url.concat(`&populate=${params.populate}`);

    return this.http.get<any>(url).pipe(retry(1), catchError(this.handleError));
  }

  /**
   * HttpClient API get() method => paginate tinhTp with start page = 1 and limit
   * @param params
   * @returns
   */
  paginateS(params: {
    page: number;
    limit: number;
    filter: string;
    fields: string;
    populate: string;
    fieldsSearch: any;
    keywordsSearch: any;
  }
  ): Observable<any> {
    let url = `${this.apiURL}/stores/paginate?page=${params.page}&limit=${params.limit}&${params.filter}` + '&isAdmin';

    if (params.fields) url = url.concat(`&fields=${params.fields}`);
    if (params.populate) url = url.concat(`&populate=${params.populate}`);

    if (params.keywordsSearch) url = url.concat(`&keywordsSearch=${params.keywordsSearch}`);
    if (params.fieldsSearch) url = url.concat(`&fieldsSearch=${params.fieldsSearch}`);


    return this.http.get<any>(url).pipe(retry(1), catchError(this.handleError));
  }

  /*========================================
    Begin Custom Methods for RESTful API
  =========================================*/

  /**
   * Error handling
   * @param error
   * @returns
   */
  handleError(error: any) {
    let errorMessage = '';

    if (error.error instanceof ErrorEvent) {
      // Get client-side error
      errorMessage = error.error.message;
    } else {
      // Get server-side error
      errorMessage = `Error Code: ${error.status}\nMessage: ${error.message}`;
    }

    // log error when call api
    console.log(
      'ERROR: API: ',
      error.url,
      ' Status:',
      error?.status,
      error?.error?.errors[0]
    );

    return throwError(error);
  }
}
